import { arrayOfDiscussions } from "~/schemas/schema.discussions.jsx";
import { arrayOfFiles } from "~/schemas/schema.files.jsx";
import { arrayOfNotes } from "~/schemas/schema.notes.jsx";
import { projectTemplate } from "~/schemas/schema.project_templates.jsx";
import * as schemaProjectCategories from "~/schemas/schema.projectCategories.jsx";
import * as schemaProjects from "~/schemas/schema.projects.jsx";
import { arrayOfRecurringTasks } from "~/schemas/schema.recurring_tasks.jsx";
import { arrayOfSubtasks } from "~/schemas/schema.subtasks.jsx";
import * as schemaTaskLists from "~/schemas/schema.task_lists.jsx";
import { arrayOfTaskLists } from "~/schemas/schema.task_lists.jsx";
import * as schemaTasks from "~/schemas/schema.tasks.jsx";
import { arrayOfTasks } from "~/schemas/schema.tasks.jsx";
import {
  FETCH_PROJECT_LOADING,
  FETCH_PROJECT_SUCCESS,
  FETCH_PROJECT_ERROR,
  FETCH_PROJECT_ADDITIONAL_DATA_LOADING,
  FETCH_PROJECT_ADDITIONAL_DATA_SUCCESS,
  FETCH_PROJECT_ADDITIONAL_DATA_ERROR,
} from "~/store/action_types";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";
import { param } from "~/utils/url_helper.jsx";
import { encodeData } from "~/utils/utils.jsx";
import * as trashActions from "./actions.trash.jsx";

export const addProject = (attributes) => {
  return {
    types: [actionTypes.ADD_PROJECT_LOADING, actionTypes.ADD_PROJECT_SUCCESS, actionTypes.ADD_PROJECT_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      attributes,
      schema: {
        single: schemaProjects.project,
      },
    },
  };
};

export const addProjectFromDataSet = (attributes) => {
  return {
    types: [
      actionTypes.ADD_PROJECT_FROM_DATASET_LOADING,
      actionTypes.ADD_PROJECT_FROM_DATASET_SUCCESS,
      actionTypes.ADD_PROJECT_FROM_DATASET_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/create-from-data`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      attributes,
      schema: {
        project: schemaProjects.project,
        task_lists: schemaTaskLists.arrayOfTaskLists,
        tasks: schemaTasks.arrayOfTasks,
      },
    },
  };
};

export const applyProjectTemplate = (projectId, attributes) => {
  return {
    types: [
      actionTypes.PROJECT_TEMPLATE_APPLY_LOADING,
      actionTypes.PROJECT_TEMPLATE_APPLY_SUCCESS,
      actionTypes.PROJECT_TEMPLATE_APPLY_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/applied-templates`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      projectId,
      attributes,
      schema: {
        task_lists: arrayOfTaskLists,
        tasks: arrayOfTasks,
        subtasks: arrayOfSubtasks,
        recurring_tasks: arrayOfRecurringTasks,
        notes: arrayOfNotes,
        discussions: arrayOfDiscussions,
        files: arrayOfFiles,
      },
    },
  };
};

export const editProject = (project_id, attributes) => {
  return {
    types: [actionTypes.EDIT_PROJECT_LOADING, actionTypes.EDIT_PROJECT_SUCCESS, actionTypes.EDIT_PROJECT_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${project_id}`,
        method: `put`,
        body: attributes,
      }),
    payload: {
      project_id,
      attributes,
      schema: {
        single: schemaProjects.project,
      },
    },
  };
};

export const fetchProjectsForScreen = (params = {}) => {
  params = {
    ...params,
    view: params.view || "list",
  };

  const url = `${Angie.api_url}/projects/for-screen?${param(params)}`;

  return {
    types: [
      actionTypes.FETCH_PROJECTS_FOR_SCREEN_LOADING,
      actionTypes.FETCH_PROJECTS_FOR_SCREEN_SUCCESS,
      actionTypes.FETCH_PROJECTS_FOR_SCREEN_ERROR,
    ],
    callAPI: () =>
      fetch({
        url,
      }),
    payload: {
      schema: schemaProjects.arrayOfProjects,
    },
    cache: { key: url },
  };
};

export const fetchProject = (projectId, prefetchNext) => {
  const url = `${Angie.api_url}/projects/${projectId}`;
  return {
    types: [FETCH_PROJECT_LOADING, FETCH_PROJECT_SUCCESS, FETCH_PROJECT_ERROR],
    callAPI: () => fetch({ url: url, prefetchNext }),
    payload: {
      projectId,
      schema: {
        single: schemaProjects.project,
      },
    },
    cache: {
      key: url,
    },
  };
};

export const fetchProjectAdditionalData = (projectId) => {
  const url = `${Angie.api_url}/projects/${projectId}/additional-data`;
  return {
    types: [
      FETCH_PROJECT_ADDITIONAL_DATA_LOADING,
      FETCH_PROJECT_ADDITIONAL_DATA_SUCCESS,
      FETCH_PROJECT_ADDITIONAL_DATA_ERROR,
    ],
    callAPI: () => fetch({ url }),
    payload: {
      projectId,
    },
    cache: { key: url },
  };
};

export const loadProjects = () => {
  return {
    types: [actionTypes.FETCH_PROJECTS_LOADING, actionTypes.FETCH_PROJECTS_SUCCESS, actionTypes.FETCH_PROJECTS_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects`,
      }),
    payload: {
      schema: schemaProjects.arrayOfProjects,
    },
  };
};

export const loadCompanyProjects = (companyId) => {
  return {
    types: [
      actionTypes.FETCH_COMPANY_PROJECTS_LOADING,
      actionTypes.FETCH_COMPANY_PROJECTS_SUCCESS,
      actionTypes.FETCH_COMPANY_PROJECTS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/companies/${companyId}/projects`,
      }),
    payload: {
      schema: schemaProjects.arrayOfProjects,
    },
  };
};

/**
 * @deprecated use query - useProjectsNames
 * @param signal
 * @returns {{types: (string)[], callAPI: (function(): *)}}
 */
export const loadProjectsIdName = (signal) => {
  return {
    types: [actionTypes.LOAD_REQUEST, actionTypes.LOAD_PROJECTS_ID_NAME, actionTypes.LOAD_FAILURE],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/names`,
        signal,
      }),
  };
};

export const fetchClosedProjects = (page = 1) => {
  return {
    types: [
      actionTypes.FETCH_CLOSED_PROJECTS_LOADING,
      actionTypes.FETCH_CLOSED_PROJECTS_SUCCESS,
      actionTypes.FETCH_CLOSED_PROJECTS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/archive?${encodeData({ page })}`,
        withHeaders: true,
      }),
    payload: {
      schema: schemaProjects.arrayOfProjects,
    },
  };
};

/**
 * @deprecated - use react hook - useProjectsTrackingEnabled
 * @returns {{types: (string)[], callAPI: (function(): *)}}
 */
export const loadProjectsWithTrackingEnabledIdName = () => {
  return {
    types: [actionTypes.LOAD_REQUEST, actionTypes.LOAD_PROJECTS_ID_NAME, actionTypes.LOAD_FAILURE],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/with-tracking-enabled`,
      }),
  };
};

export const inviteMembers = (projectId, userIds) => {
  return {
    types: [
      actionTypes.ADD_MEMBERS_TO_PROJECT_LOADING,
      actionTypes.ADD_MEMBERS_TO_PROJECT_SUCCESS,
      actionTypes.ADD_MEMBERS_TO_PROJECT_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/members`,
        method: `post`,
        body: userIds,
      }),
    payload: {
      projectId,
      userIds,
    },
  };
};

export const removeMember = (projectId, userId) => {
  return {
    types: [
      actionTypes.REMOVE_MEMBER_FROM_PROJECT_LOADING,
      actionTypes.REMOVE_MEMBER_FROM_PROJECT_SUCCESS,
      actionTypes.REMOVE_MEMBER_FROM_PROJECT_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/members/${userId}`,
        method: `delete`,
      }),
    payload: {
      projectId,
      userId,
    },
  };
};

export const replaceMember = (projectId, userId, replaceWithUserId) => {
  return {
    types: [
      actionTypes.REPLACE_MEMBER_ON_PROJECT_LOADING,
      actionTypes.REPLACE_MEMBER_ON_PROJECT_SUCCESS,
      actionTypes.REPLACE_MEMBER_ON_PROJECT_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/members/${userId}`,
        method: `put`,
        body: {
          replace_with_id: replaceWithUserId,
          send_notification: true,
        },
      }),
    payload: {
      projectId,
      userId,
      replaceWithUserId,
    },
  };
};

export const membershipGrantedFromEventStream = (data) => {
  return {
    type: actionTypes.PROJECT_MEMBERSHIP_GRANTED_FROM_EVENT_STREAM,
    response: data,
    schema: schemaProjects.project,
  };
};

export const membershipRevokedFromEventStream = (data, loggedUserId, isLoggedUserOwner) => {
  return {
    type: actionTypes.PROJECT_MEMBERSHIP_REVOKED_FROM_EVENT_STREAM,
    response: data,
    loggedUserId,
    isLoggedUserOwner,
    schema: schemaProjects.project,
  };
};

export const projectCreatedFromEventStream = (data) => {
  return {
    type: actionTypes.ADD_PROJECT_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaProjects.project,
  };
};

export const projectUpdatedFromEventStream = (data) => {
  return {
    type: actionTypes.EDIT_PROJECT_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaProjects.project,
    id: data.id,
  };
};

export const projectCompletedFromEventStream = (data) => {
  return {
    type: actionTypes.PROJECT_COMPLETED_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaProjects.project,
    id: data.id,
  };
};

export const projectReopenedFromEventStream = (data) => {
  return {
    type: actionTypes.PROJECT_REOPENED_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaProjects.project,
    id: data.id,
  };
};

export const projectMovedToTrashFromEventStream = (data) => {
  return {
    type: actionTypes.PROJECT_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaProjects.project,
    id: data.id,
  };
};

export const projectRestoredFromTrashFromEventStream = (data) => {
  return {
    type: actionTypes.PROJECT_RESTORED_FROM_TRASH_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemaProjects.project,
    id: data.id,
  };
};

export const fetchProjectsBudgetingData = () => {
  return {
    types: [
      actionTypes.FETCH_PROJECTS_BUDGETING_DATA_LOADING,
      actionTypes.FETCH_PROJECTS_BUDGETING_DATA_SUCCESS,
      actionTypes.FETCH_PROJECTS_BUDGETING_DATA_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/budgeting-data`,
      }),
  };
};

export const batchEditBudgetTypes = (attributes) => {
  return {
    types: [
      actionTypes.BATCH_EDIT_BUDGET_TYPES_LOADING,
      actionTypes.BATCH_EDIT_BUDGET_TYPES_SUCCESS,
      actionTypes.BATCH_EDIT_BUDGET_TYPES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/batch-update-budget-types`,
        method: `put`,
        body: attributes,
      }),
    payload: {
      attributes,
      schema: schemaProjects.arrayOfProjects,
    },
  };
};

export const openProject = (id) => {
  return {
    types: [actionTypes.OPEN_PROJECT_LOADING, actionTypes.OPEN_PROJECT_SUCCESS, actionTypes.OPEN_PROJECT_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/open/project/${id}`,
        method: `put`,
      }),
    payload: {
      id,
      schema: {
        single: schemaProjects.project,
        task_lists: schemaTaskLists.arrayOfTaskLists,
        category: schemaProjectCategories.projectCategory,
      },
    },
  };
};

export const completeProject = (id) => {
  return {
    types: [
      actionTypes.COMPLETE_PROJECT_LOADING,
      actionTypes.COMPLETE_PROJECT_SUCCESS,
      actionTypes.COMPLETE_PROJECT_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/complete/project/${id}`,
        method: `PUT`,
      }),
    payload: {
      id,
      schema: {
        single: schemaProjects.project,
        task_lists: schemaTaskLists.arrayOfTaskLists,
        category: schemaProjectCategories.projectCategory,
      },
    },
  };
};

export const duplicateProject = (id, attributes) => {
  return {
    types: [
      actionTypes.DUPLICATE_PROJECT_LOADING,
      actionTypes.DUPLICATE_PROJECT_SUCCESS,
      actionTypes.DUPLICATE_PROJECT_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/projects/${id}/duplicate`,
        method: "POST",
        body: attributes,
      }),
    payload: {
      id,
      schema: {
        single: schemaProjects.project,
      },
    },
  };
};

export const moveToTrash = (id) => {
  const objectType = "Project";
  return {
    ...trashActions.moveToTrash(objectType, id),
    types: [
      actionTypes.MOVE_PROJECT_TO_TRASH_LOADING,
      actionTypes.MOVE_PROJECT_TO_TRASH_SUCCESS,
      actionTypes.MOVE_PROJECT_TO_TRASH_ERROR,
    ],
    payload: {
      id,
      objectType,
      schema: {
        single: schemaProjects.project,
        task_lists: schemaTaskLists.arrayOfTaskLists,
        category: schemaProjectCategories.projectCategory,
      },
    },
  };
};

export const convertToTemplate = (project_id, name, attributes) => {
  return {
    types: [
      actionTypes.CONVERT_TO_TEMPLATE_LOADING,
      actionTypes.CONVERT_TO_TEMPLATE_SUCCESS,
      actionTypes.CONVERT_TO_TEMPLATE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/project-templates`,
        method: `POST`,
        body: attributes,
      }),
    payload: {
      project_id,
      name,
      schema: {
        single: projectTemplate,
      },
    },
  };
};

export const fetchResponsibilities = (id) => {
  return {
    types: [
      actionTypes.FETCH_RESPONSIBILITIES_LOADING,
      actionTypes.FETCH_RESPONSIBILITIES_SUCCESS,
      actionTypes.FETCH_RESPONSIBILITIES_ERROR,
    ],
    callAPI: () => fetch({ url: `${Angie.api_url}/projects/${id}/responsibilities` }),
  };
};

export const fetchProjectsDetails = () => {
  return {
    types: [
      actionTypes.FETCH_PROJECTS_DETAILS_LOADING,
      actionTypes.FETCH_PROJECTS_DETAILS_SUCCESS,
      actionTypes.FETCH_PROJECTS_DETAILS_ERROR,
    ],
    callAPI: () => fetch({ url: `${Angie.api_url}/projects/details` }),
    payload: {
      schema: schemaProjects.arrayOfProjects,
    },
  };
};

export const addUserToProjects = (userId, projectIds) => {
  return {
    types: [
      actionTypes.ADD_USER_TO_PROJECTS_LOADING,
      actionTypes.ADD_USER_TO_PROJECTS_SUCCESS,
      actionTypes.ADD_USER_TO_PROJECTS_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/${userId}/projects`,
        method: `post`,
        body: projectIds,
      }),
    payload: {
      userId,
      projectIds,
    },
  };
};
